import { useTheme } from "../context/ThemeContext";

/** The light/dark toggle, reused by the auth screens and the app top bar. */
export function PortalModeToggle() {
  const { mode, toggleMode } = useTheme();
  return (
    <button
      type="button"
      className="mode-toggle"
      aria-label={mode === "dark" ? "Switch to light mode" : "Switch to dark mode"}
      onClick={toggleMode}
    >
      {mode === "dark" ? (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
        </svg>
      ) : (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="12" cy="12" r="4.2" />
          <path d="M12 2v2.5M12 19.5V22M4.2 4.2l1.8 1.8M18 18l1.8 1.8M2 12h2.5M19.5 12H22M4.2 19.8L6 18M18 6l1.8-1.8" />
        </svg>
      )}
    </button>
  );
}
